import React from "react";
import classNames from "classnames";
import { FormattedMessage, useIntl } from "react-intl";
import { Tooltip } from "@mui/material";
import IconLoader from "components/IconLoader/IconLoader";
import {
  Dropdown,
  DropdownButton,
  OverlayTrigger,
  Popover,
  PopoverBody,
  PopoverHeader
} from "react-bootstrap";
import { isFunction } from "lodash";
const TableAction = ({
  title,
  icon,
  onClick,
  disabled,
  active,
  id,
  children,
  withLabel,
  dropdownBtn,
  dropdownItems,
  dropdownAction,
  gridAction,
  labelParams,
  popoverButton,
  popoverParams,
  loading = false
}) => {
  const intl = useIntl();

  const getDropdownButton = () => {
    return (
      // <Tooltip title={title ? intl.formatMessage({ id: title }) : title}>
      // <div>
      <DropdownButton
        disabled={disabled}
        id={id}
        title={<IconLoader icon={icon} size={1} />}
        className={gridAction ? "lms-gridaction-dropdown" : "lms-tableaction-dropdown"}
      >
        {dropdownItems.map((item, index) => (
          <Dropdown.Item
            key={item.text + index}
            onClick={(event) => {
              isFunction(event?.stopPropagation) && event?.stopPropagation();
              dropdownAction(item.type);
            }}
          >
            {item.text}
          </Dropdown.Item>
        ))}
      </DropdownButton>
      // </div>
      // </Tooltip>
    );
  };

  const renderContent = () => {
    return (
      <li>
        <button
          type="button"
          className={classNames({
            "table-action-btn": true,
            "table-action-btn-active": active
          })}
          onClick={() => !loading && onClick()}
          disabled={disabled}
          id={id ? id : "lms-button"}
          style={withLabel ? { width: "auto" } : null}
        >
          <Tooltip title={title ? intl.formatMessage({ id: title }) : title}>
            <span>
              {loading ? (
                <span className="spinner spinner-primary pr-12" />
              ) : (
                <IconLoader icon={icon} size={1} />
              )}
            </span>
          </Tooltip>
          {withLabel && (
            <span className="w-100 pt-3 pl-2">
              <FormattedMessage id={title} values={labelParams || {}} />
            </span>
          )}
          {children}
        </button>
      </li>
    );
  };

  const getPopoverButton = () => {
    return (
      <OverlayTrigger
        trigger={popoverParams?.trigger || "focus"}
        placement={popoverParams?.placement || "bottom"}
        overlay={
          <Popover style={{ width: popoverParams?.width || "280px", margin: 0 }}>
            <PopoverHeader>{popoverParams?.header}</PopoverHeader>
            <PopoverBody>{popoverParams?.body()}</PopoverBody>
          </Popover>
        }
      >
        <li>
          <button
            type="button"
            className={classNames({
              "table-action-btn": true,
              "table-action-btn-active": active
            })}
            disabled={disabled}
            id={id ? id : "lms-button"}
            style={withLabel ? { width: "auto" } : null}
          >
            <Tooltip title={title ? intl.formatMessage({ id: title }) : title}>
              <span>
                <IconLoader icon={icon} size={1} />
              </span>
            </Tooltip>
          </button>
        </li>
      </OverlayTrigger>
    );
  };
  if (popoverButton) return getPopoverButton();
  else if (dropdownBtn) return getDropdownButton();
  else return renderContent();
};

export default TableAction;
